module.exports = __webpack_public_path__ + "img/applepay_googlepay.3cc11ab1.png";